/**
 * Enumeration of temperature units.
 *
 * @readonly
 * @enum {string}
 */
export const TemperatureUnits = Object.freeze({
    CELSIUS: 'Celsius',
    FAHRENHEIT: 'Fahrenheit'
})
